// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__3dbxb","left":"StickyBox_left__3CIpR","right":"StickyBox_right__2UVDT"};